

class PageType {
    /** Stranka pro vsechny produkty */
    ProductsByCoupon: boolean;

    /** Kosik - stary */
    BasketPage: boolean;

    /** Sdileni kosiku */
    ShareBasketPage: boolean;

    /** Kosik krok 1 */
    BasketStep1Page: boolean;

    /** Kosik krok 2 */
    BasketStep2Page: boolean;

    /** Kosik krok 3 */
    BasketStep3Page: boolean;

    /** Kosik krok 4 */
    BasketStep4Page: boolean;

    /** Kosik kork 5 */
    BasketStep5Page: boolean;

    /** Bazar stranka */
    BazaarPage: boolean;

    /** Blog */
    BlogPage: boolean;

    /** Kategorie */
    CategoryPage: boolean;

    /** Specialni kategorie */
    CategorySpecialPage: boolean;

    /** Kategorie */
    CategoryTitlePage: boolean;

    /** Detail zbozi */
    DetailPage: boolean;

    /** Emailove novinky */
    EmailNewsPage: boolean;

    /** Stranka chyby */
    ErrorPage: boolean;

    /** Vsechny stranky */
    EveryPage: boolean;

    /** Připojení externího účtu k uživatelskému účtu */
    ExternalConnect: boolean;

    /** Rychloobjednavka */
    FastOrderPage: boolean;

    /** Forum */
    ForumPage: boolean;

    /** Slovnik pojmu */
    GlossaryOfTermsPage: boolean;

    /** Heureka recenze */
    HeurekaReviewPage: boolean;

    /** HTML site mapa */
    HtmlSiteMapPage: boolean;

    /** Članky ale ne publish */
    InfoPage: boolean;

    /** Stranka prodejen */
    Markets: boolean;

    /** Stranka detailu prodejny */
    MarketDetail: boolean;

    /** Novinky emailem  (bMalingPage) */
    NewsLetterPage: boolean;

    /** Objednavky */
    OrdersPage: boolean;

    /** Hodnoceni objednavky(bMailReview) */
    OrderReviewPage: boolean;

    /** Partnerska administrace */
    PartnerAdminPage: boolean;

    /** Partner registrace */
    PartnerRegistration: boolean;

    /** Heslo na mail */
    PasswordOnMailPage: boolean;

    /** Platebni proces */
    PaymentProcessPage: boolean;

    /** Portal detail */
    PortalDetailPage: boolean;

    /** Obecná stránka */
    PortalPage: boolean;

    /** Stranka vyrobce */
    ProducerPage: boolean;

    /** Clanek detail */
    PublishArticlePage: boolean;

    /** Clanky kategorie */
    PublishCategoryPage: boolean;

    /** Reklamace */
    ReclamationPage: boolean;

    /** Registrace zakaznika */
    RegistrationPage: boolean;

    /** Hledani */
    SearchPage: boolean;

    /** Tagy */
    TagsPage: boolean;

    /** Titulka */
    TitlePage: boolean;

    /** Napiste nam */
    WriteToUsPage: boolean;
}

/** Preloader je aktivní */
var gPreloaderIsOn = false;

/** Typ stránky */
var pageType = new PageType();

/** Název inputu pro filtrování dle dostupnosti */
var queryStringAvail = "dostupnost";

declare var Autoplay: any;
declare var Dots: any;
declare var Arrows: any;

declare function Carousel(htmlItem: any, options: any): { init: () => void };
declare function Carousel(htmlItem: any, options: any, plugins: any): { init: () => void };
declare function globalRunOnBasket4(): void;
declare function GA4PromotionView(): void;
declare function GA4ViewItemList(): void;

interface IObjAP {
    timeout: number;
    pauseOnHover: boolean;
    showProgress: boolean;
}

/** Nastaví pageType pro všechny typy na false */
function localFnSetPaGeTypeDefault(): void {
    pageType.ProductsByCoupon = false;
    pageType.BasketPage = false;
    pageType.ShareBasketPage = false;
    pageType.BasketStep1Page = false;
    pageType.BasketStep2Page = false;
    pageType.BasketStep3Page = false;
    pageType.BasketStep4Page = false;
    pageType.BasketStep5Page = false;
    pageType.BazaarPage = false;
    pageType.BlogPage = false;
    pageType.CategoryPage = false;
    pageType.CategorySpecialPage = false;
    pageType.CategoryTitlePage = false;
    pageType.DetailPage = false;
    pageType.EmailNewsPage = false;
    pageType.ErrorPage = false;
    pageType.EveryPage = false;
    pageType.ExternalConnect = false;
    pageType.FastOrderPage = false;
    pageType.ForumPage = false;
    pageType.GlossaryOfTermsPage = false;
    pageType.HeurekaReviewPage = false;
    pageType.HtmlSiteMapPage = false;
    pageType.InfoPage = false;
    pageType.Markets = false;
    pageType.MarketDetail = false;
    pageType.NewsLetterPage = false;
    pageType.OrdersPage = false;
    pageType.OrderReviewPage = false;
    pageType.PartnerAdminPage = false;
    pageType.PartnerRegistration = false;
    pageType.PasswordOnMailPage = false;
    pageType.PaymentProcessPage = false;
    pageType.PortalDetailPage = false;
    pageType.PortalPage = false;
    pageType.ProducerPage = false;
    pageType.PublishArticlePage = false;
    pageType.PublishCategoryPage = false;
    pageType.ReclamationPage = false;
    pageType.RegistrationPage = false;
    pageType.SearchPage = false;
    pageType.TagsPage = false;
    pageType.TitlePage = false;
    pageType.WriteToUsPage = false;
}

/** Načtení pageType z třídy na elementu body */
function localFnGetPageType(): void {
    const body = $("body");

    if (body.hasClass("body-index")) {
        pageType.TitlePage = true;
    } else if (body.hasClass("body-item")) {
        pageType.DetailPage = true;
    } else if (body.hasClass("body-category")) {
        pageType.CategoryPage = true;
    } else if (body.hasClass("body-search")) {
        pageType.SearchPage = true;
    } else if (body.hasClass("body-tags")) {
        pageType.TagsPage = true;
    } else if (body.hasClass("body-error")) {
        pageType.ErrorPage = true;
    } else if (body.hasClass("body-orders")) {
        pageType.OrdersPage = true;
    } else if (body.hasClass("body-reg-partner") || body.hasClass("body-portal-reg")) {
        pageType.PartnerRegistration = true;
    } else if (body.hasClass("body-portal-profil-edit")) {
        pageType.PartnerAdminPage = true;
    } else if (body.hasClass("body-admin-partner")) {
        pageType.PartnerAdminPage = true;
    } else if (body.hasClass("body-detail-partner")) {
        pageType.PortalDetailPage = true;
    } else if (body.hasClass("body-mailnews")) {
        pageType.EmailNewsPage = true;
    } else if (body.hasClass("body-book")) {
        pageType.WriteToUsPage = true;
    } else if (body.hasClass("body-newsletter")) {
        pageType.NewsLetterPage = true;
    } else if (body.hasClass("body-registration")) {
        pageType.RegistrationPage = true;
    } else if (body.hasClass("body-passwordonmail")) {
        pageType.PasswordOnMailPage = true;
    } else if (body.hasClass("body-publish-cat")) {
        pageType.PublishCategoryPage = true;
    } else if (body.hasClass("body-bazaar")) {
        pageType.BazaarPage = true;
    } else if (body.hasClass("body-forum")) {
        pageType.ForumPage = true;
    } else if (body.hasClass("body-blog")) {
        pageType.BlogPage = true;
    } else if (body.hasClass("body-search")) {
        pageType.SearchPage = true;
    } else if (body.hasClass("body-info")) {
        pageType.InfoPage = true;
    } else if (body.hasClass("body-heurekarecenze")) {
        pageType.HeurekaReviewPage = true;
    } else if (body.hasClass("body-mailreview")) {
        pageType.OrderReviewPage = true;
    } else if (body.hasClass("body-basket")) {
        pageType.BasketPage = true;
    } else if (body.hasClass("body-basket-1")) {
        pageType.BasketStep1Page = true;
    } else if (body.hasClass("body-basket-2")) {
        pageType.BasketStep2Page = true;
    } else if (body.hasClass("body-basket-3")) {
        pageType.BasketStep3Page = true;
    } else if (body.hasClass("body-basket-4")) {
        pageType.BasketStep4Page = true;
    } else if (body.hasClass("body-basket-5")) {
        pageType.BasketStep5Page = true;
    } else if (body.hasClass("body-tags")) {
        pageType.TagsPage = true;
    } else if (body.hasClass("body-htmlsitemap")) {
        pageType.HtmlSiteMapPage = true;
    } else if (body.hasClass("body-paymentprocess") || body.hasClass("body-paymentprocessstatus") || body.hasClass("body-paymentprocessrepeat")) {
        pageType.PaymentProcessPage = true;
    } else if (body.hasClass("body-couponcommoditypage")) {
        pageType.ProductsByCoupon = true;
    } else if (body.hasClass("body-fastorder")) {
        pageType.FastOrderPage = true;
    } else if (body.hasClass("body-producer")) {
        pageType.ProducerPage = true;
    } else if (body.hasClass("body-markets")) {
        pageType.Markets = true;
    } else if (body.hasClass("body-glossaryofterms")) {
        pageType.GlossaryOfTermsPage = true;
    } else if (body.hasClass("body-detail-market")) {
        pageType.MarketDetail = true;
    } else if (body.hasClass("body-reclamation")) {
        pageType.ReclamationPage = true;
    } else if (body.hasClass("body-external-connect")) {
        pageType.ExternalConnect = true;
    } else if (body.hasClass("body-portal-page")) {
        pageType.PortalPage = true;
    } else if (body.hasClass("body-article")) {
        pageType.PublishArticlePage = true;
    } else if (body.hasClass("body-publich-cat")) {
        pageType.PublishCategoryPage = true;
    } else if (body.hasClass("body-share")) {
        pageType.ShareBasketPage = true;
    }
}

/** spuštění procedur pro každý pageType */
function localFnRunPageScripts(): void {
    if (typeof globalRunAllEverywhere === "function") { globalRunAllEverywhere(); }

    if (pageType.BasketPage) {
        if (typeof globalRunOnBasket === "function") { globalRunOnBasket(); }
    }
    else if (pageType.BasketStep1Page) {
        if (typeof globalRunOnBasket1 === "function") { globalRunOnBasket1(); }
    } else if (pageType.BasketStep2Page) {
        if (typeof globalRunOnBasket2 === "function") { globalRunOnBasket2(); }
    } else if (pageType.BasketStep3Page) {
        if (typeof globalRunOnBasket3 === "function") { globalRunOnBasket3(); }
    } else if (pageType.BasketStep4Page) {
        if (typeof globalRunOnBasket4 === "function") { globalRunOnBasket4(); }
    } else if (pageType.CategoryPage) {
        if (typeof globalRunAllOnCategorySpecial === "function" && $('body').hasClass('special-cat')) {
            globalRunAllOnCategorySpecial();
        }
        //if (typeof globalRunAllOnCategory === "function")
        //{
        //    globalRunAllOnCategory();
        //}
        if (typeof globalRunAllOnCategoryOrSearch === "function") {
            globalRunAllOnCategoryOrSearch();
        }

    }
    //else if (pageType.DetailPage) {
    //    if (typeof globalRunOnDetail === "function") { globalRunOnDetail(); }
    //} 
    else if (pageType.PublishArticlePage) {
        if (typeof globalRunOnPublishArticle === "function") { globalRunOnPublishArticle(); }
    } else if (pageType.PublishCategoryPage) {
        if (typeof globalRunOnPublishCategory === "function") { globalRunOnPublishCategory(); }
    } else if (pageType.RegistrationPage) {
        if (typeof globalRunOnRegistrationShop === "function") { globalRunOnRegistrationShop(); }
    } else if (pageType.TitlePage) {
        if (typeof globalRunOnTitle === "function") { globalRunOnTitle(); }
    }
    else if (pageType.SearchPage) {
        //if (typeof globalRunAllOnSearch === "function") { globalRunAllOnSearch(); }
        if (typeof globalRunAllOnCategoryOrSearch === "function") { globalRunAllOnCategoryOrSearch(); }
    }
}

/** Pro všechny prvky s třídou availFancy nastaví tooltip */
function availability(): void {
    $(".availFancy").unbind();
    $(".availFancy").on("click", function (event) {
        event.preventDefault();
        preloader(true);
        const prod = $(this).data("id");
        EshopService("StockAvailability", { itemId: prod }, true, (result: InfoValueResult) => {
            preloader(false);
            $.fancybox.open(result.Value);

        });
    });
}

/**
 * Nastaví cookie
 * @param cname název
 * @param cvalue hodnota
 * @param exdays expirace ve dnech
 */
function setCookie(cname: string, cvalue: any, exdays: number): void {
    const d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    const expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";path=/;" + expires;
}

/**
 * Načtení cookie
 * @param cname název
 */
function getCookie(cname: string): string {
    const name = cname + "=";
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1);
        if (c.indexOf(name) === 0) return c.substring(name.length, c.length);
    }
    return "";
}

/**
 * Načtení parametru z URL
 * @param url URL
 * @param parm název parametru
 */
function getParmFromHash(url: string, parm: string): string {
    let re = new RegExp(".*[?&]" + parm + "=([^&]+)(&|$)");
    let match = url.match(re);
    return (match ? match[1] : "");
}

/**
 * Načtení parametru z hash části URL
 * @param hash kompletní hash (window.location.hash)
 * @param parm parametr
 */
function getParmFromUrlHash(hash: string, parm: string): string {
    let re = new RegExp(".*[#&]" + parm + "=([^&]+)(&|$)");
    let match = hash.match(re);
    return (match ? match[1] : "");
}

/**
 * Otevření přihlašovacího okna
 * @param event událost kliknutí
 * @param callback callback událost po otevření okna
 */
function clickOnLogin(event: any, callback: any): void {
    event.preventDefault();
    if ($.fancybox.getInstance()) {
        $.fancybox.getInstance().close(event);
    }
    setTimeout(function () {
        $("html, body").animate({
            scrollTop: top
        }, 400);
        $("#linkLoginForm").trigger("click");

        if (typeof callback === "function") {
            callback();
        }
    }, 300);
}

/**
 * Validace emailu na správný formát
 * @param email email k validaci
 */
function RunMailContr(adresa: string): boolean {
    var re = /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    return (adresa.search(re) === 0);
}


function setOwl(
    htmlItem: string,
    useLoop: boolean,
    useClass: boolean,
    useNav: boolean,
    useDots: boolean,
    marginValue: number,
    useAutoPlay: boolean,
    responsiveItems: any,
    useLazy: boolean,
    linkNextItem: string = "",
    stopOnHover: boolean = false,
    autoplayTimeout: number = 0
): void {
    if (!$(htmlItem).length) return;

    $('.nocarousel', htmlItem).remove();

    if (linkNextItem) {
        const $first = $(htmlItem).children(':first');
        const tn = $first.prop('tagName').toLowerCase();
        const tc = ($first.prop('class') || '') + ' next_in_owl';
        const t = GetTextDynamic('next_in_owl');
        let it = `<${tn} class="${tc}"><a href="${linkNextItem}">${t}</a></${tn}>`;
        if (tn === 'a') it = `<${tn} class="${tc}" href="${linkNextItem}">${t}</${tn}>`;
        $(htmlItem).append(it);
    }

    $(htmlItem)
        .children('div, a, img, span, li, figure, article')
        .each(function () {
            $(this).addClass('f-carousel__slide');
        });

    const hasAutoplay = useAutoPlay && typeof Autoplay !== 'undefined';
    const hasNavigation = useNav && typeof Arrows !== 'undefined';
    const hasDots = useDots && typeof Dots !== 'undefined';
   
    const autoplayOpts = {
        timeout: autoplayTimeout || 3000,
        pauseOnHover: stopOnHover,
        showProgress: false,
    };

    const options: any = {
        infinite: useLoop,
        center: false,
        fill: true,
        autoFocus: false,
        slidesPerPage: "auto",
        Autoplay: hasAutoplay ? autoplayOpts : false,
        on: {
            change: (instance: any) => {
                setTimeout(() => {
                    if (htmlItem.indexOf('BannImg_') > -1) GA4PromotionView();
                    if (htmlItem.indexOf('Items') > -1) GA4ViewItemList();
                }, 300);
            },
            ready: (instance: any) => {
                setTimeout(() => {
                    if (htmlItem.indexOf('BannImg_') > -1) GA4PromotionView();
                    if (htmlItem.indexOf('Items') > -1) GA4ViewItemList();
                }, 300);
            },
        },
    };

    const plugins: any = {};
    if (hasAutoplay) plugins.Autoplay = Autoplay;
    if (hasDots) plugins.Dots = Dots;
    if (hasNavigation) plugins.Arrows = Arrows;

    const htmlItemNative = document.querySelector(htmlItem);
    if (!htmlItemNative) return;

    const carouselInstance = Object.keys(plugins).length
        ? Carousel(htmlItemNative, options, plugins).init()
        : Carousel(htmlItemNative, options).init();
}


function setLoginLinks() {
    $("body").on("click", ".loginLink", function (e) {
        clickOnLogin(e, () => { $("#frmLoginForm input[name=logEmail]").focus(); });
    });
}

function AddItemToLocalStorage(itemName, itemValue) {
    try {
        var ok = CheckLocalStorage();
        if (ok) {
            localStorage.setItem(itemName, itemValue);
        }
    } catch (e) {
        console.log(e);
    }
}

function DelItemFromLocalStorage(itemName) {
    try {
        var ok = CheckLocalStorage();
        if (ok) {
            localStorage.removeItem(itemName);
        }
    } catch (e) {
        console.log(e);
    }
}

function GetItemFromLocalStorage(itemName) {
    try {
        var ok = CheckLocalStorage();
        if (ok) {
            return localStorage.getItem(itemName);
        }

        return "";

    } catch (e) {
        console.log(e);
        return "";
    }
}

function CheckLocalStorage() {
    try {
        return (typeof (Storage) !== "undefined" && navigator.cookieEnabled == true);
    } catch (e) {
        return false;
    }
}


function AddItemToSessionStorage(itemName, itemValue) {
    try {
        var ok = CheckSessionStorage();
        if (ok) {
            sessionStorage.setItem(itemName, itemValue);
        }
    } catch (e) {
        console.log(e);
    }
}

function DelItemFromSessionStorage(itemName) {
    try {
        var ok = CheckSessionStorage();
        if (ok) {
            sessionStorage.removeItem(itemName);
        }
    } catch (e) {
        console.log(e);
    }
}

function GetItemFromSessionStorage(itemName) {
    try {
        var ok = CheckSessionStorage();
        if (ok) {
            return sessionStorage.getItem(itemName);
        }

        return "";
    } catch (e) {
        console.log(e);
        return "";
    }
}

function CheckSessionStorage() {
    try {
        return (typeof (Storage) !== "undefined" && navigator.cookieEnabled == true);
    } catch (e) {
        return false;
    }
}




/**
 * Načtení settingu jako JSON
 * @param name název settingu
 */
function getSetting(name: string): any {
    let retVal;
    EshopService("GetSetting", { settingName: name }, false, (result: InfoResult) => {
        if (result.ErrorLevel === 0) {
            retVal = JSON.parse(result.Message);
        } else {
            console.log(result.Message);
        }
    });
    return retVal;
}


function overlayOnBody(state, classname) {
    classname = (typeof classname !== 'undefined') ? classname : 'overlay-open';
    if (typeof state === 'undefined') {
        $('body').toggleClass(classname);
    }
    else if (state) {
        $('body').addClass(classname);
    }
    else {
        $('body').removeClass(classname);
    }
}

function fancyMessage(title: string, message: string, type: string) {
    var content = "<div class='fancy-message type-" + type + "'><div class='modal__header'><h2>" + title + "</h2></div><div class='modal__content'>" + message + "</div></div>";
    $.fancybox.open(content,
        {
            afterLoad: function (instance, current) {
                ;
            }
        });
}

function MobileDetect() {
    if ($(window).width() < 1101) {
        $("body").addClass("is-mobile");
    }
    else {
        $("body").removeClass("is-mobile");
    }
}

$(document).ready(() => {
    MobileDetect();
    pageType = new PageType();
    localFnSetPaGeTypeDefault();
    localFnGetPageType();
    localFnRunPageScripts();
    // setLoginLinks();
});